import { useDeviceType } from '@cian/ui-kit';

import { ButtonLink } from '../../components/ButtonLink';
import { IMessageBubbleProps, MessageBubble } from '../../components/MessageBubble/MessageBubble';
import { useBubbleClamp } from '../../hooks';
import * as styles from './ExpandableBubbleContainer.css';

interface IExpandableBubbleContainerProps extends IMessageBubbleProps {
  maxHeight: number;
}

export const ExpandableBubbleContainer = ({ maxHeight, ...rest }: IExpandableBubbleContainerProps) => {
  const device = useDeviceType();
  const isDesktop = device === 'desktop';
  const textClassName = 'text';
  const expandButtonClassName = styles['expand'];

  const { rootRef, onExpandButtonClick, isCollapsed } = useBubbleClamp({
    maxHeight,
    expandButtonClassName,
    textClassName,
  });

  if (isDesktop) {
    return <MessageBubble {...rest} />;
  }

  return (
    <MessageBubble
      {...rest}
      rootRef={rootRef}
      textClassName={textClassName}
      expandButton={
        isCollapsed && (
          <ButtonLink onClick={onExpandButtonClick} className={expandButtonClassName}>
            Читать полностью
          </ButtonLink>
        )
      }
    />
  );
};
